import React from "react";
import {useParams} from "react-router-dom";
import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientDocumentInfo from "../../../components/client/document/ClientDocumentInfo";

//클라이언트 문서 상세 페이지
const ClientDocumentInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //문서 식별자가 없는 경우
    if (!id) {
        return <div>Invalid document ID</div>;
    }

    return (
        <ClientLayout>
            {/*클라이언트 문서 상세 정보*/}
            <ClientDocumentInfo documentId={parseInt(id)}/>
        </ClientLayout>
    )
}

export default ClientDocumentInfoPage;